import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue-demi';
import { Picker } from '@onereach/emoji-picker-element';
import { openBlock, createElementBlock } from 'vue';

var script = defineComponent({
  setup() {
    const container = ref();
    //for now work only with light theme
    const isDark = ref(false);
    let picker = new Picker();
    function updatePickerProps() {
      // hide skin tone picker
      const style = document.createElement('style');
      style.textContent = '.skintone-button-wrapper {display: none !important;} .search-row {padding: 0.5rem !important;}';
      picker.shadowRoot.appendChild(style);
      picker.classList.toggle('dark', isDark.value);
      picker.classList.toggle('light', !isDark.value);
      picker.classList.add('w-full');
    }
    onMounted(() => {
      updatePickerProps();
      if (container.value) {
        container.value.appendChild(picker);
      }
    });
    onBeforeUnmount(() => {
      if (container.value) {
        container.value.removeChild(picker);
      }
    });
    return {
      isDark,
      container,
      picker,
      updatePickerProps
    };
  }
});

const _hoisted_1 = {
  ref: "container",
  class: "w-full"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, null, 512 /* NEED_PATCH */);
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "emoji-picker {\n  --background: inherit;\n  --border-size: 0;\n}";
styleInject(css_248z);

script.render = render;
script.__file = "src/components/EmojiPicker/EmojiPicker.vue";

export { script as s };
